module.exports = new __parcel__URL__("profile-photo.2103ea77.svg").toString();